var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-full flex flex-row relative items-center"},[_c('div',{staticClass:"w-full"},[_c('carousel',{ref:"carousel",attrs:{"perPage":1,"scrollPerPage":true,"paginationEnabled":false,"mouseDrag":false},on:{"page-change":_vm.pageChanged}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }